import { render } from "./social_inbox.vue?vue&type=template&id=60fc2fd6&scoped=true"
import script from "./social_inbox.vue?vue&type=script&lang=js"
export * from "./social_inbox.vue?vue&type=script&lang=js"

import "./social_inbox.vue?vue&type=style&index=0&id=60fc2fd6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fc2fd6"]])

export default __exports__